import { useEffect, useRef } from 'react';
import { isEqual } from 'lodash';

export const usePrevious = <T>(value: T, comparison: (prev: T, next: T) => boolean = isEqual): T => {
    const prevRef = useRef(value);
    useEffect(() => {
        if (!comparison(value, prevRef.current)) {
            prevRef.current = value;
        }
    }, [value]);
    return prevRef.current;
};
